import FloatingVideoButton from '../../../../commons/buttons/FloatingVideoButton';
import Select from 'react-select';

const customStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: 60,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};


function AdAccountSection({ adAccounts, pages, values, errors, touched, setFieldValue, isEdit }) {
    const adAccountOptions = adAccounts.map(acc => ({
        value: acc.id,
        label: `${acc.name || acc.id} ${acc.currency ? `(${acc.currency})` : ''}`
    }));

    const pageOptions = pages.map(page => ({
        value: page.id,
        label: page.name
    }));



    return (
        <div className="create-ad-section">
            <h4 className="create-ad-section-title">Conta e Páginasss</h4>

            <div style={{ marginBottom: '20px' }}>
                <label style={{ fontWeight: 600, marginBottom: '8px', display: 'block' }}>
                    Conta de Anúncios  <span style={{ color: '#d00' }}>*</span>
                </label>
                <Select
                    isDisabled={isEdit}
                    styles={customStyles}
                    options={adAccountOptions}
                    placeholder="Selecione a conta de anúncios..."
                    value={adAccountOptions.find(opt => opt.value === values.adAccountId)}
                    onChange={(selected) => setFieldValue('adAccountId', selected?.value || '')}
                    isClearable
                    isSearchable
                />
                {errors.adAccountId && touched.adAccountId && (
                    <div style={{ color: '#dc3545', fontSize: '14px', marginTop: '5px' }}>
                        {errors.adAccountId}
                    </div>
                )}
            </div>

            <div style={{ marginBottom: '20px' }}>
                <label style={{ fontWeight: 600, marginBottom: '8px', display: 'block' }}>
                    Página do Facebook <span style={{ color: '#d00' }}>*</span>
                </label>
                <Select
                    isDisabled={isEdit}
                    styles={customStyles}
                    options={pageOptions}
                    placeholder="Selecione a página..."
                    value={pageOptions.find(opt => opt.value === values.pageId)}
                    onChange={(selected) => setFieldValue('pageId', selected?.value || '')}
                    isClearable
                    isSearchable
                />
                {errors.pageId && touched.pageId && (
                    <div style={{ color: '#dc3545', fontSize: '14px', marginTop: '5px' }}>
                        {errors.pageId}
                    </div>
                )}
            </div>


        </div>
    );
}

export default AdAccountSection;